export default __webpack_public_path__ + "static/media/goshen87.95a896f6.jpg";